import {FC} from 'react';
import {useField} from 'formik';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import useShow, {TShow} from '../../../../../hooks/useShow';
import {RootState} from '../../../../../redux/store.type';
import {TLecturer} from '../../../../../redux/timetable/timetable.type';
import {teamMemberPhoto} from '../../../../../assets/symbols/images/teamMemberPhoto';
import {personOutline} from '../../../../../assets/symbols/symbols/Symbols.css';
import SelectPopup from '../../../../../component/selectPopup/SelectPopup';
import AddLecturerPopup from './AddLecturerPopup/AddLecturerPopup';

interface Props {
    show: TShow;
}

const LecturersSelectPopup: FC<Props> = ({show}) => {
    const {t} = useTranslation('timetable');
    const [field, , helpers] = useField<number[]>('lecturerIds');
    const lecturers = useSelector((state: RootState) => state.timetable.lecturers);
    const addLecturerShow = useShow();

    return (
        <>
            <SelectPopup
                show={show}
                title={t('lecturers')}
                items={lecturers.map((l: TLecturer) => ({
                    id: l.lid,
                    text: `${l.firstName} ${l.lastName}`.trim(),
                    image: l.image || teamMemberPhoto,
                }))}
                multiSelect
                selectedIds={field.value}
                onConfirm={ids => helpers.setValue(ids)}
                addAction={{
                    text: t('addLecturer'),
                    emptyText: t('addNewLecturer'),
                    onClick: () => {
                        show.close();
                        addLecturerShow.open();
                    },
                }}
                empty={{
                    icon: personOutline,
                    text: t('noLecturersYet'),
                    noResultsText: term => (
                        <>{t('noResultsFor', {term})}<br />{t('tryAnotherName')}</>
                    ),
                }}
            />
            <AddLecturerPopup
                show={{
                    ...addLecturerShow,
                    close: async (e) => {
                        await addLecturerShow.close(e);
                        show.open();
                    },
                }}
            />
        </>
    );
};

export default LecturersSelectPopup;
